import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { logoCinza } from 'components/Logo';
import './style.scss';
const styles = (theme) => ({});
class LoadingComponent extends Component {
	render() {
		return (
			<div id="loading-model">
				<div style={{ bottom: 0, left: 0, overflow: 'hidden', position: 'absolute', right: 0, top: 0 }}>
					<div
						style={{
							animation: 'a-h .5s 1.25s 1 linear forwards,a-nt .6s 1.25s 1 cubic-bezier(0,0,.2,1)',
							background: '#eee',
							borderRadius: '50%',
							height: '800px',
							left: '50%',
							margin: '-448px -400px 0',
							position: 'absolute',
							top: '50%',
							transform: 'scale(0)',
							width: '800px'
						}}
					/>
				</div>
				<div style={{ height: '100%', textAlign: 'center' }}>
					<div style={{ height: '50%', margin: '0 0 -140px' }} />
					<div style={{ height: '128px', margin: '0 auto', position: 'relative', width: '176px' }}>
						<img
							src={logoCinza}
							alt="logo-azapfy"
							className="img-fluid animated zoomInDown animation-duration-3 animation-delay-20 img-loading"
						/>
						
					</div>
					<div id="nlptLoad" />
					<div style={{ animation: 'a-s .25s 1.25s 1 forwards', opacity: 0 }} className="msg-load">
						Carregando Módulo&hellip;
					</div>
				</div>
			</div>
		);
	}
}

export default LoadingComponent;
